(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-b2b"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mergeB2bFields(form) {
      var bodyField = form.querySelector('[data-b2b-body-field]');
      if (!bodyField) return;

      var wrap = form.closest('.section-b2b__form-wrap');
      var mergeHeader = (wrap && wrap.getAttribute('data-b2b-merge-header')) || '';
      var mergeNotes = (wrap && wrap.getAttribute('data-b2b-merge-notes')) || '';
      var lines = [];
      if (mergeHeader) lines.push(mergeHeader);
      lines.push('');
      form.querySelectorAll('[data-b2b-field]').forEach(function (el) {
        var label = el.getAttribute('data-b2b-label') || '';
        var value = (el.value || '').trim();
        if (value) lines.push(label + ': ' + value);
      });

      var notes = (bodyField.value || '').trim();
      if (notes) {
        lines.push('');
        lines.push(mergeNotes || '');
        lines.push(notes);
      }

      bodyField.value = lines.join('\n');
    }

    function initSectionB2bForms() {
      document.querySelectorAll('form.section-b2b__form').forEach(function (form) {
        if (form.dataset.b2bBound === '1') return;
        form.dataset.b2bBound = '1';
        form.addEventListener('submit', function () {
          mergeB2bFields(form);
        });
      });
    }

    initSectionB2bForms();
    document.addEventListener('shopify:section:load', initSectionB2bForms);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-krijo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mergeB2bFields(form) {
      var bodyField = form.querySelector('[data-b2b-body-field]');
      if (!bodyField) return;

      var wrap = form.closest('.section-b2b__form-wrap');
      var mergeHeader = (wrap && wrap.getAttribute('data-b2b-merge-header')) || '';
      var mergeNotes = (wrap && wrap.getAttribute('data-b2b-merge-notes')) || '';
      var lines = [];
      if (mergeHeader) lines.push(mergeHeader);
      lines.push('');
      form.querySelectorAll('[data-b2b-field]').forEach(function (el) {
        var label = el.getAttribute('data-b2b-label') || '';
        var value = (el.value || '').trim();
        if (value) lines.push(label + ': ' + value);
      });

      var notes = (bodyField.value || '').trim();
      if (notes) {
        lines.push('');
        lines.push(mergeNotes || '');
        lines.push(notes);
      }

      bodyField.value = lines.join('\n');
    }

    function initSectionB2bForms() {
      document.querySelectorAll('form.section-b2b__form').forEach(function (form) {
        if (form.dataset.b2bBound === '1') return;
        form.dataset.b2bBound = '1';
        form.addEventListener('submit', function () {
          mergeB2bFields(form);
        });
      });
    }

    initSectionB2bForms();
    document.addEventListener('shopify:section:load', initSectionB2bForms);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zh-brand-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function scrollSnapAmount(viewport) {
    var item = viewport.querySelector('.zh-brand-slider__item');
    if (!item) return Math.round(viewport.clientWidth * 0.45);
    var track = item.parentElement;
    var gapRaw = '';
    try {
      gapRaw = window.getComputedStyle(track).gap || window.getComputedStyle(track).columnGap || '0';
    } catch (_) {
      gapRaw = '0';
    }
    var gapNum = parseFloat(gapRaw) || 0;
    return Math.round(item.getBoundingClientRect().width + gapNum * 3);
  }

  function updateArrowState(viewport, prevBtn, nextBtn, carousel) {
    if (!viewport || (!prevBtn && !nextBtn)) return;
    if (carousel && carousel.hasAttribute('data-brand-js-marquee')) {
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
      return;
    }
    var max = viewport.scrollWidth - viewport.clientWidth;
    var tol = 4;
    var canScroll = max > tol;

    if (prevBtn) {
      prevBtn.disabled = !!(canScroll && viewport.scrollLeft <= tol);
    }
    if (nextBtn) {
      nextBtn.disabled = !!(canScroll && viewport.scrollLeft >= max - tol);
    }
  }

  function bindCarouselImages(viewport, onScroll) {
    viewport.querySelectorAll('img.zh-brand-slider__logo').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener(
          'load',
          function () {
            window.requestAnimationFrame(onScroll);
          },
          { passive: true }
        );
      }
    });
  }

  /** Continuous scroll marquee when arrows are enabled (CSS transform marquee cannot run alongside overflow scroll). */
  function attachJsMarquee(carousel, viewport, ribbon) {
    if (!carousel || !viewport || carousel.getAttribute('data-brand-js-marq-bound') === '1') return;
    if (!carousel.hasAttribute('data-brand-js-marquee')) return;

    var reducedMotion = false;
    try {
      reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_) {}
    if (reducedMotion) return;

    carousel.setAttribute('data-brand-js-marq-bound', '1');

    var ms = parseInt(carousel.getAttribute('data-brand-marquee-ms'), 10);
    if (!ms || ms < 4000) ms = 55000;

    function nowTs() {
      return typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
    }

    var lastTs = nowTs();
    var rafId = null;

    function onRibbonEnter() {
      carousel._brandMarqueeHoverPause = true;
    }
    function onRibbonLeave() {
      carousel._brandMarqueeHoverPause = false;
    }
    if (ribbon) {
      ribbon.addEventListener('mouseenter', onRibbonEnter, { passive: true });
      ribbon.addEventListener('mouseleave', onRibbonLeave, { passive: true });
    }

    carousel._brandMarqueeStop = function stopMarquee() {
      if (rafId !== null && typeof cancelAnimationFrame !== 'undefined') {
        cancelAnimationFrame(rafId);
      }
      rafId = null;
      carousel._brandMarqueeStop = undefined;
      if (ribbon) {
        ribbon.removeEventListener('mouseenter', onRibbonEnter);
        ribbon.removeEventListener('mouseleave', onRibbonLeave);
      }
    };

    function tick() {
      rafId = window.requestAnimationFrame(tick);

      var wrap = viewport.scrollWidth / 2;
      if (!(wrap > 48)) return;

      var now = nowTs();
      var dt = Math.min(Math.max(now - lastTs, 0), 64);
      lastTs = now;

      var until = carousel._brandMarqueeUserUntil || 0;
      if (now < until || carousel._brandMarqueeHoverPause) return;

      var dx = (wrap / ms) * dt;

      viewport.scrollLeft += dx;
      var sl = viewport.scrollLeft;
      if (sl >= wrap - 0.5) {
        viewport.scrollLeft = sl - wrap;
      }
    }

    lastTs = nowTs();
    rafId = window.requestAnimationFrame(tick);
  }

  function bindCarousel(root) {
    var carousel = root.querySelector('.zh-brand-slider__carousel[data-brand-slider-nav]');
    if (!carousel || carousel.getAttribute('data-brand-nav-bound') === '1') return;
    carousel.setAttribute('data-brand-nav-bound', '1');
    var viewport = carousel.querySelector('.zh-brand-slider__viewport--scroll');
    var wrap = carousel.closest('.zh-brand-slider__carousel-shell');
    if (!viewport || !wrap) return;
    var prevBtn = wrap.querySelector('[data-brand-prev]');
    var nextBtn = wrap.querySelector('[data-brand-next]');
    var track = viewport.querySelector('.zh-brand-slider__track');

    function onScroll() {
      updateArrowState(viewport, prevBtn, nextBtn, carousel);
    }

    function scheduleMeasure() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(onScroll);
      });
    }

    function pauseMarqueeBriefly() {
      carousel._brandMarqueeUserUntil = typeof performance !== 'undefined' ? performance.now() + 2600 : 0;
    }

    function step(dir) {
      pauseMarqueeBriefly();
      var max = viewport.scrollWidth - viewport.clientWidth;
      if (max <= 4) return;
      var amount = scrollSnapAmount(viewport) * dir;
      try {
        viewport.scrollBy({ left: amount, behavior: 'smooth' });
      } catch (_) {
        viewport.scrollLeft += amount;
      }
      window.setTimeout(onScroll, 380);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        step(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        step(1);
      });
    }
    viewport.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        scheduleMeasure();
      },
      { passive: true }
    );
    window.addEventListener(
      'load',
      function () {
        scheduleMeasure();
      },
      { passive: true }
    );

    bindCarouselImages(viewport, scheduleMeasure);

    if (typeof ResizeObserver !== 'undefined' && track) {
      try {
        var ro = new ResizeObserver(function () {
          scheduleMeasure();
        });
        ro.observe(viewport);
        ro.observe(track);
      } catch (_) {}
    }

    scheduleMeasure();
    window.setTimeout(scheduleMeasure, 400);

    var ribbonEl = carousel.closest('.zh-brand-slider__ribbon');
    attachJsMarquee(carousel, viewport, ribbonEl);
  }

  function initScope(scope) {
    var root = scope && scope.nodeType ? scope : document;
    root.querySelectorAll('.zh-brand-slider').forEach(function (sectionEl) {
      bindCarousel(sectionEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScope(document);
    });
  } else {
    initScope(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (root && root.querySelector) initScope(root);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.zh-brand-slider__carousel[data-brand-js-marquee]').forEach(function (carousel) {
      if (carousel && typeof carousel._brandMarqueeStop === 'function') {
        carousel._brandMarqueeStop();
      }
      carousel.removeAttribute('data-brand-js-marq-bound');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
